import bill from './bill'
import contract from './contract'

const defaultValues = {
  contract,
  bill,
}

export default defaultValues
